module.exports = __webpack_public_path__ + "img/farzana-christopher-131.5ce53eb2.jpg";